"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientPlugins = void 0;
var initialize_1 = require("./initialize");
/**
 * Fetch all client plugins.
 * Depends on HooksBootstrapPlugin. See {@link HooksBootstrapPlugin}
 */
var getClientPlugins = function () {
    // load old plugins bundle if it's available, else read it from the new config bundle
    try {
        if (typeof process.env.BERNIE_plugins__client === 'string') {
            // TODO: backward compatibility code, remove this after legacy config goes away
            var pluginsEntry = require(process.env.BERNIE_plugins__client);
            var plugins = (pluginsEntry && pluginsEntry.plugins) || [];
            return (0, initialize_1.initializePlugins)(plugins);
        }
        else {
            var plugins = require(process.env.BERNIE_client_config_module);
            return (0, initialize_1.initializePlugins)(plugins);
        }
    }
    catch (e) {
        return [];
    }
};
exports.getClientPlugins = getClientPlugins;
//# sourceMappingURL=get-client-plugins.js.map